import{apolloQuery as e}from"../graphql/index.js";import{GetNewsletterPackagesDocument as a}from"../types/generated.js";var t=new class{constructor(){this.getPackages=()=>e({query:a}).then((e=>e.data.packages))}};export{t as default};
